const devStore = require("./configureStore.dev");
const prodStore = require("./configureStore.prod");

if (document.location.hostname !== "localhost" || process.env.NODE_ENV === "production") {
    module.exports = prodStore;
} else {
    module.exports = devStore;
}
